import { WorkMovementRestrictionWidgetStore } from './work-movement-restriction-widget.store';
import { translate } from '../../../../../shared/shared.global-service';
import { Component, computed, inject, input } from '@angular/core';
import { WorkTypeEnum } from '@libs/types/src/common/enum/work-type.enum';
import {
    dateFromColumnWithTime,
    folderPersonColumn,
    serviceField,
} from '../../../../../shared/components/kit/table/table.fields';
import { getRestrictionsFrag } from './work-movement-restriction-widget.query';
import { FilterBuilder } from '../../../../helper/filter.builder';
import { UserWidgetSetting } from '@libs/types/src/services/types/service-settings-user-widgets.type';
import { TableComponent } from '../../../../../shared/components/kit/table/table.component';

@Component({
    selector: 'app-work-movement-restriction-widget',
    templateUrl: './work-movement-restriction-widget.component.html',
    styleUrl: './work-movement-restriction-widget.component.scss',
    providers: [WorkMovementRestrictionWidgetStore],
    imports: [
        TableComponent,
    ],
})
export class WorkMovementRestrictionWidgetComponent {

    public readonly store = inject(WorkMovementRestrictionWidgetStore);

    items = input<{ serviceId: string, widget: UserWidgetSetting }[]>([]);

    protected columns = computed(() => {
        const showServiceInfo = [...new Set(this.items().map(x => x.serviceId))].length > 1;

        let cols = [
            folderPersonColumn,
            {
                name: 'workData.swdmr.type',
                dataKey: 'workData.type',
                data: (item: any) => item ? translate.instant(`workData.movementRestriction.type.${item}`) : null,
            },
            dateFromColumnWithTime,
        ];

        if (showServiceInfo) {
            cols = [
                ...cols.slice(0, 1),
                serviceField('service', 'serviceId'),
                ...cols.slice(1),
            ];
        }

        return cols;
    });

    protected additionalFilters = computed<any>(() => {
        const filter = new FilterBuilder();
        filter
            .serviceIds(this.items().map(x => x.serviceId))
            .workType(WorkTypeEnum.MOVEMENT_RESTRICTION)
            .validByNow('dateFrom', 'dateTo')
        ;

        return filter.filter()?.filter || [];
    });

    protected readonly getRestrictionsFrag = getRestrictionsFrag;
}
